import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtAgo } from "@/lib/localServer";
import { CloudOff, CloudUpload, Cloud } from "lucide-react";

export function useLocalPublicStatus(pollMs = 0) {
  const [st, setSt] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/local/public-status").then(r => { if (alive) setSt(r.data); }).catch(() => {});
    load();
    const t = pollMs ? setInterval(load, pollMs) : null;
    return () => { alive = false; if (t) clearInterval(t); };
  }, [pollMs]);
  return st;
}

export function SyncIndicator({ canOpen }) {
  const st = useLocalPublicStatus(20000);
  const navigate = useNavigate();
  if (!st || st.mode !== "local" || st.setup_required) return null;
  const offline = st.online === false;
  const pending = (st.pending || 0) + (st.failed || 0);
  const Icon = offline ? CloudOff : pending ? CloudUpload : Cloud;
  const tone = offline ? "text-destructive border-destructive/40" : st.failed ? "text-yellow-500 border-yellow-500/40" : "text-emerald-500 border-emerald-500/40";
  const label = offline ? "Offline" : pending ? `${pending} to sync` : "Synced";
  return (
    <button type="button" data-testid="sync-indicator" disabled={!canOpen}
      onClick={() => canOpen && navigate("/settings/local-server")}
      title={`Last cloud sync ${fmtAgo(st.last_success)}`}
      className={`hidden sm:flex items-center gap-1.5 border px-2 h-7 text-[11px] uppercase tracking-[0.12em] ${tone} ${canOpen ? "hover:bg-muted/40" : "cursor-default"}`}>
      <Icon className="w-3.5 h-3.5" />
      <span data-testid="sync-indicator-label">{label}</span>
      <span className="text-muted-foreground normal-case tracking-normal">· {fmtAgo(st.last_success)}</span>
    </button>
  );
}
